import DragAndDropFileUploader from './DragAndDropFileUploader';

export default DragAndDropFileUploader;
